import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
    warranty: number;
}

export const WarrantyText: React.FC<Props> = ({ warranty }) => {
    return (
        <>
            {warranty >= 1 && warranty <= 5 && (
                <span>
                    <FormattedMessage id="Warranty" />:{' '}
                    {warranty === 1 ? (
                        <FormattedMessage id="One_Additional_Year" />
                    ) : warranty === 2 ? (
                        <FormattedMessage id="Two_Additional_Years" />
                    ) : warranty === 3 ? (
                        <FormattedMessage id="Three_Additional_Years" />
                    ) : warranty === 4 ? (
                        <FormattedMessage id="Four_Additional_Years" />
                    ) : warranty === 5 ? (
                        <FormattedMessage id="Five_Additional_Years" />
                    ) : (
                        <></>
                    )}
                </span>
            )}
        </>
    );
};

export default WarrantyText;
